import { createContext, useContext } from 'react';
import type { Permission } from '@/types/portal';

/** The signed-in staff member's role, built from `GET /cpaas/me`. */
export interface CurrentRole {
  id: string;
  name: string;
  approvalsCeiling: string;
  permissions: Permission[];
}

export interface RoleContextValue {
  roleId: string;
  role: CurrentRole;
  permissions: Permission[];
  can: (permission: Permission) => boolean;
}

export const RoleContext = createContext<RoleContextValue | null>(null);

export function useRole() {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
}
